"use client";

import { useEffect } from "react";
import ErrorPage from "@/components/sections/errors/ErrorPage";

export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		// Log the error to an error reporting service
		console.error("Global application error:", error);
	}, [error]);

	return <ErrorPage type="500" reset={reset} />;
}
